/**
 * Chave pública do Google reCAPTCHA v2 (checkbox).
 * Crie em https://www.google.com/recaptcha/admin — tipo reCAPTCHA v2 "Não sou um robô"
 * No .env: REACT_APP_RECAPTCHA_SITE_KEY=sua_chave_site
 */
const RECAPTCHA_SITE_KEY_ENV = (process.env.REACT_APP_RECAPTCHA_SITE_KEY || '').trim();
export const RECAPTCHA_SITE_KEY = RECAPTCHA_SITE_KEY_ENV;

export const getRecaptchaSiteKey = (remoteSiteKey) => {
  const remote = (remoteSiteKey || '').trim();
  return remote || RECAPTCHA_SITE_KEY_ENV;
};

export const isRecaptchaConfigured = (remoteSiteKey) =>
  getRecaptchaSiteKey(remoteSiteKey).length > 0;

/** Se true, não chama a Cloud Function (apenas valida presença do token — só para dev local). */
export const RECAPTCHA_SKIP_SERVER_VERIFY =
  process.env.REACT_APP_RECAPTCHA_SKIP_SERVER_VERIFY === 'true';
